import React from "react";
import QuestionForm from "../QuestionForm";
import { QuestionsSectionProps } from "./types";
import { Question } from "../../../interfaces/questions.interface";

export const QuestionsSection: React.FC<QuestionsSectionProps> = ({
  category,
  onQuestionAdded,
  editingQuestion,
  onQuestionEdited
}) => {
  const handleSubmit = (question: Omit<Question, '_id' | 'chapter'>) => {
    if (editingQuestion && onQuestionEdited) {
      onQuestionEdited(question);
    } else if (!editingQuestion && onQuestionAdded) {
      onQuestionAdded(question);
    }
  };

  return (
    <div>
      <QuestionForm
        category={category}
        onSubmit={handleSubmit}
        initialValues={editingQuestion}
        submitLabel={editingQuestion ? "Modifier la question" : "Ajouter la question"}
      />
    </div>
  );
};
